import EA from '../helpers/init';

export default EA.Methods.calculateHeaderBannerHeight = ($this) => {
    const headerBanner = $this;
    const mobileMenu = $this.querySelector('.mobile-menu-container');

    mobileMenu.style.paddingTop = `${headerBanner.offsetHeight}px`;
};
